import React, { useState, useEffect } from "react";
import classes from "./AudioPlayer.module.scss";
import {
  faPlay,
  faPause,
  faStop,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { Box, Typography } from "@mui/material";
import RoundedButton from "../Buttons/RoundedButton";
import { BTN_TYPE_GRAY } from "../../constants/buttons";
import { useTranslation } from "react-i18next";
import axios from "../../axios";
import { setAnalyticsPlayAudio } from "../../helpers/analyticsHelpers";
import { useSelector } from "react-redux";
import * as kApi from "../../constants/api";
import { Auth } from "aws-amplify";
import * as h from "../../helpers/index";

const AudioPlayer = ({
  disable = true,
  center = null,
  url_audio = "",
  toStop = null,
  marginBottom = false,
  name = "(player_component_error_nome)",
  id = "(player_component_error_id)",
  className = "",
}) => {
  const { t } = useTranslation();
  const { session, activeUser } = useSelector((state) => state.session);
  const my_user = session?.my_user;
  const [msg, setMsg] = useState(null);
  const [audio, setAudio] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [countAnalytics, setCountAnalytics] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [content, setContent] = useState(<div />);
  const [audioSlider, setAudioSlider] = useState(<div />);
  const [isLoading, setIsLoading] = useState(true);

  let type = activeUser ? "patient_in_fono" : my_user?.typeUser;

  useEffect(() => {
    if (!audio) {
      const newAudio = new Audio(url_audio);
      setIsLoading(true);
      newAudio.addEventListener("canplaythrough", () => {
        setIsLoading(false);
      });
      setAudio(newAudio);
    }
  }, [url_audio]);

  const stopOnLockScreen = () => {
    if (playing) {
      pause();
    }
  };

  useEffect(
    () => () => {
      if (playing) {
        audio.pause();
      }
    },
    [playing, audio]
  );

  useEffect(() => {
    document.addEventListener("visibilitychange", stopOnLockScreen);
    // window.addEventListener("blur", stopOnLockScreen);
    return () => {
      document.removeEventListener("visibilitychange", stopOnLockScreen);
      // window.removeEventListener("blur", stopOnLockScreen);
    };
  });

  // Salva a reprodução do áudio no backend
  const saveAudio = () => {
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
      let audioDuration = Math.floor(audio.duration);
      let minutes = Math.floor(audioDuration / 60);
      let seconds = audioDuration - minutes * 60;

      const audioFormatted =
        ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
      if (session) {
        const userID = activeUser ? activeUser.sub : session.sub;
        const requestBody = JSON.stringify({
          jogo: name,
          id_jogo: id,
          pontos: 0,
          nivel: 0,
          id_usuario: userID,
          time: audioFormatted,
          language: "pt_br",
          miscellaneous: { type: "audio", platform: "web" },
          plays: [],
          configuration: {
            currentRoundChanged: 0,
            timeConfigChanged: 0,
            configState: [],
          },
        });

        fetch(kApi.API_Q_SCORE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: Auth.user.signInUserSession.idToken.jwtToken,
          },
          body: JSON.stringify(requestBody),
        })
          .then(async (res) => {
            if (!res.ok) throw { response: { status: res.status } };
            return res.json();
          })
          .then((res) => {
            setMsg(t("global.audio_saved"));
            h.UpdateLocalAmountPlay(userID);
          })
          .catch((err) => {
            if (
              err.response &&
              parseInt(err.response.status) === 404
            ) {
              setMsg(t("global.audio_saved"));
            } else {
              try {
                Auth.currentAuthenticatedUser()
                  .then((cognitoUser) => {
                    Auth.currentSession().then((currentSession) =>
                      cognitoUser.refreshSession(
                        currentSession.refreshToken,
                        (err, session) =>
                          fetch(kApi.API_Q_SCORE, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: session.idToken.jwtToken,
                            },
                            body: JSON.stringify(requestBody),
                          })
                            .then(async (res) => {
                              if (!res.ok) throw { response: { status: res.status } };
                              return res.json();
                            })
                            .then((res) => {
                              setMsg(t("global.audio_saved"));
                              h.UpdateLocalAmountPlay(userID);
                            })
                            .catch((err) => {
                              if (
                                err.response &&
                                parseInt(err.response.status) === 404
                              )
                                setMsg(t("global.audio_saved"));
                              else setMsg(t("global.error_to_save"));
                            })
                      )
                    );
                  })
                  .catch((err) => {
                    setMsg(t("global.error_to_save"));
                  });
              } catch (e) {
                setMsg(t("global.error_to_save"));
              }
            }
          });

        // axios
        //   .post(kApi.API_Q_SCORE, requestBody, {
        //     headers: {
        //       Authorization: Auth.user.signInUserSession.idToken.jwtToken,
        //     },
        //   })
        //   .then((res) => {
        //     // if (Boolean(res.data)) setMsg(t("global.audio_saved"));
        //     // else setMsg(t("global.error_to_save"));
        //     setMsg(t("global.audio_saved"));
        //     h.UpdateLocalAmountPlay(userID);
        //   })
        //   .catch((err) => {
        //     if (
        //       err.response &&
        //       parseInt(err.response.status) === parseInt(404)
        //     ) {
        //       setMsg(t("global.audio_saved"));
        //     } else {
        //       try {
        //         Auth.currentAuthenticatedUser()
        //           .then((cognitoUser) => {
        //             Auth.currentSession().then((currentSession) =>
        //               cognitoUser.refreshSession(
        //                 currentSession.refreshToken,
        //                 (err, session) =>
        //                   axios
        //                     .post(kApi.API_Q_SCORE, requestBody, {
        //                       headers: {
        //                         Authorization: session.idToken.jwtToken,
        //                       },
        //                     })
        //                     .then((res) => {
        //                       setMsg(t("global.audio_saved"));
        //                       h.UpdateLocalAmountPlay(userID);
        //                     })
        //                     .catch((err) => {
        //                       if (
        //                         err.response &&
        //                         parseInt(err.response.status) === parseInt(404)
        //                       )
        //                         setMsg(t("global.audio_saved"));
        //                       else setMsg(t("global.error_to_save"));
        //                     })
        //               )
        //             );
        //           })
        //           .catch((err) => {
        //             setMsg(t("global.error_to_save"));
        //           });
        //       } catch (e) {
        //         setMsg(t("global.error_to_save"));
        //       }
        //     }
        //   });
      } else {
        setMsg(t("global.error_to_save"));
      }
    }
  };

  const updateValueSlider = () => {
    if (!playing) {
      setSliderValue(audio.currentTime);
      setTimeout(updateValueSlider, 200);
    }
  };

  const play = () => {
    setPlaying(true);
    audio.play();
    updateValueSlider();
  };

  const pause = () => {
    setPlaying(false);
    setCountAnalytics(false);
    audio.pause();
  };

  const stop = () => {
    audio.pause();
    setPlaying(false);
    toStop && toStop(false);
    audio.currentTime = 0;
    setSliderValue(0);
  };

  const handleChangeSlider = (event) => {
    setSliderValue(event.target.value);
    audio.currentTime = sliderValue;
  };

  useEffect(() => {
    if (!audio) return;
    audio.onended = () => {
      saveAudio();
    };

    const handleDecrementTime = () => {
      const newTime = audio.currentTime - 15 > 0 ? audio.currentTime - 15 : 0;
      audio.currentTime = newTime;
    };

    const handlePlayPause = () => {
      if (isPlaying) {
        pause();
      } else {
        countAnalytics && setAnalyticsPlayAudio({ name, id });
        play();
      }
      setIsPlaying(!isPlaying);
    };

    setContent(
      <Box sx={{ display: "flex", gap: "10px" }}>
        <RoundedButton
          disable={disable}
          title={isPlaying ? t("global.to_pause") : t("global.to_play_audio")}
          onClick={handlePlayPause}
          faIcon={isPlaying ? faPause : faPlay}
          testId={`audioPlayer_${(isPlaying ? t("pauseAudio") : t("playAudio"))}_btn`}
        />
        <RoundedButton
          disable={disable}
          title={t("global.back_15_secondes")}
          onClick={handleDecrementTime}
          faIcon={faUndo}
          testId="audioPlayer_back15Seconds_btn"
        />
        {msg && (
          <Typography>
            <strong>{msg}</strong>
          </Typography>
        )}
        <RoundedButton
          disable={disable}
          type={BTN_TYPE_GRAY}
          title={t("global.to_stop")}
          onClick={stop}
          faIcon={faStop}
          testId="audioPlayer_stop_btn"
        />
      </Box>
    );
    if (audio.duration) {
      const duration = audio.duration;
      const minutes = Math.floor(sliderValue / 60);
      const seconds = String(Math.floor(sliderValue % 60)).padStart(2, "0");
      const formattedTime = `${minutes}:${seconds}`;

      setAudioSlider(
        <Box className={classes.FlexLine}>
          <input
            type="range"
            min="0"
            value={sliderValue}
            max={parseInt(duration)}
            onChange={handleChangeSlider}
            step="1"
            className={classes.Slider}
          />
          <Typography>{formattedTime}</Typography>
        </Box>
      );
    }
  }, [audio, isPlaying, sliderValue, disable, msg, isLoading]);

  return (
    <Box
      className={`${classes.MsgArea} ${center ? classes.Center : ""} ${
        marginBottom ? classes.MarginBottom : ""
      } ${className || ""}`.trim()}
    >
      {audioSlider}
      <Box style={{ display: "flex" }}>{content}</Box>
    </Box>
  );
};

export default AudioPlayer;
